<template>
    <auth-layout>
        <header-page title="Reward" />
        <div class="mt-5 reward-page">
            <header-page title="Article Reward"/>
            <div class="article-reward" v-if="!loadingArticle">
                <table class="table" id="statistic-table" v-if="articles.length > 0">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Views</th>
                            <th>Claim</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in articles" :key="item.title">
                            <td>
                                <a :href="'https://yoursay.suara.com' + item.path" rel="noopener" target="_blank">{{ item.title }}</a>
                            </td>
                            <td>{{ intToString(item.view_count) }}</td>
                            <td><button class="button-claim" :disabled="!item.claim" @click="claimArticle(item.article_id)">Claim</button></td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center mt-2" v-else>
                    <p>Belum ada artikel yang dapat diklaim</p>
                </div>
                <div class="button-wrap" v-if="articles.length > 0">
                    <div class="row">
                        <div class="col-6">
                            <button class="btn btn-primary main-button pill-button" @click="prevPage" :disabled="current_page === 1">Sebelumnya</button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-primary main-button pill-button bg-orange" @click="nextPage" :disabled="total_page === 1">Selanjutnya</button>
                        </div>
                    </div>
                </div>
            </div>
            <loading-block v-else />
        </div>
    </auth-layout>
</template>
<style scoped>
.reward-page {
    padding: 0 5%;
}
.article-reward {
    background: #fff;
    margin-top: 10px;
    border-radius: 10px;
    overflow: hidden;
}
.article-reward a:hover {
    text-decoration: none;
}
.button-claim {
    background: #EC550E;
    color: #fff;
    border: none;
    border-radius: 5px;
}
.button-claim:disabled,
.button-claim[disabled]{
    background: #f59366;
}
</style>
<script>
import axios from "axios";

export default {
    data() {
        return {
            articles: [],
            loadingArticle: true,
            current_page: 1,
            total_page: 1
        }
    },
    mounted() {
        this.getArticleReward()
    },
    methods: {
        async getArticleReward(page = 1) {
            this.loadingArticle = true
            const token = this.$cookies.get('token');
            await axios.get(`/api/reward/article?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.articles = response.data.data.lists;
                    this.loadingArticle = false
                    this.total_page = response.data.data.pagination.total_page
                    this.current_page = response.data.data.pagination.current_page
                })
                .catch((error) => {
                    this.loadingArticle = false
                });
        },
        nextPage(){
            const page = this.current_page + 1;
            this.getArticleReward(page)
            window.scrollTo(0,0);
        },
        prevPage() {
            const page = this.current_page - 1;
            this.getArticleReward(page)
            window.scrollTo(0,0);
        },
        claimArticle(article_id) {
            const ok = window.confirm('Klaim point artikel ini?');
            if(ok) {
                const token = this.$cookies.get('token');
                axios.post(`/api/reward/article/claim`, {article_id: article_id}, { headers: {"Authorization" : `Bearer ${token}`} })
                    .then((response) => {
                        this.getArticleReward()
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Berhasil!',
                            text: response.data.message,
                            type: 'success'
                        });
                    })
                    .catch((error) => {
                        if(error.response) {
                            this.$notify({
                                duration: 5000,
                                group: 'main',
                                title: 'Oopppss!',
                                text: error.response.data.message,
                                type: 'warn'
                            })
                        }
                    });
            }
        },
        intToString(num) {
            // source: https://www.html-code-generator.com/javascript/shorten-long-numbers
            if (num < 1000) return num;

            const si = [
                { v: 1e3, s: "K" },
                { v: 1e6, s: "M" },
                { v: 1e9, s: "B" },
                { v: 1e12, s: "T" },
                { v: 1e15, s: "P" },
                { v: 1e18, s: "E" }
            ];

            let i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].v) {
                    break;
                }
            }
            return (
                (num / si[i].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") +
                si[i].s
            );
        }
    }
}
</script>
